__turbopack_context__.v({
  "chip": "vRoU9a_chip",
  "chipContainer": "vRoU9a_chipContainer",
  "disabled": "vRoU9a_disabled",
});
